import { AssetPermissionsTableProps } from './AssetPermissionsTable'
import { Box, theme } from '@dtx-company/shared-components/src'
import { Checkbox, FormControlLabel } from '@mui/material'
import { PermissionsDropdownMenu } from './PermissionsDropdownMenu'
import { useShareWithEntireOrgState } from './hooks/useShareWithEntireOrgState'
import React from 'react'

export interface ShareWithEveryoneControlsProps
  extends Pick<
    AssetPermissionsTableProps,
    'trackingClickPermission' | 'trackingClickPermissionDropdown' | 'trackingClickShareWithEveryone'
  > {
  assetId: string
  subdomainName?: string
  isWhitelabel?: boolean
  isCodeSubdomain?: boolean
}

export const ShareWithEveryoneControls: React.FC<ShareWithEveryoneControlsProps> = ({
  assetId,
  isWhitelabel,
  isCodeSubdomain,
  trackingClickShareWithEveryone,
  trackingClickPermission
}) => {
  const state = useShareWithEntireOrgState({
    assetId,
    isWhitelabel: Boolean(isWhitelabel),
    isCodeSubdomain,
    trackingClickShareWithEveryone
  })

  return (
    <Box display="flex" pl="8px" width="100%" justifyContent="space-between" alignItems="center">
      <FormControlLabel
        control={
          <Checkbox
            checked={state.checkboxChecked}
            disableRipple
            sx={{
              color: theme.colors.primary.flowBlue,
              '&.Mui-checked': {
                color: theme.colors.primary.flowBlue
              }
            }}
            onChange={state.onChangeCheckbox}
          />
        }
        label={state.label}
      />
      {state.checkboxChecked && (
        <PermissionsDropdownMenu
          disabled={false}
          assetId={assetId}
          isWhitelabel={true}
          isCodeSubdomain={isCodeSubdomain}
          permission={state.organizationPermission}
          trackingClickPermission={trackingClickPermission}
          hideRemoveItem
        />
      )}
    </Box>
  )
}
